if (!customElements.get('blog-load-previous')) {
  customElements.define(
    'blog-load-previous',
    class BlogLoadPrevious extends HTMLElement {
      constructor() {
        super();
        this.container = this.closest('.main-blog');
        this.sectionId = this.container.dataset.id;
        this.blogGrid = this.container.querySelector('#BlogArticlesGrid .blog-articles');

        if (this.button) {
          this.button.addEventListener('click', this.handleButtonClick.bind(this));
        }
      }
      get button() {
        return this.querySelector('a');
      }
      get loadingSpinner() {
        return this.querySelector('.loading__spinner');
      }

      changePageInURL(pageNumber) {
        if (pageNumber == undefined) return;

        let url = new URL(window.location);
        url.searchParams.set('page', pageNumber);
        window.history.pushState({}, '', url);
      }

      loadPrevPage() {
        if (this.button == null) return;

        let url = this.button.href;

        this.button.classList.add('loading');
        if (this.loadingSpinner) {
          this.loadingSpinner.classList.remove('hidden');
        }

        let urlObject = new URL(url);
        let nextPageNumber = urlObject.searchParams.get('page');
        urlObject.searchParams.set('section_id', this.sectionId);

        fetch(urlObject.toString())
          .then((response) => response.text())
          .then((responseText) => {
            this.changePageInURL(nextPageNumber);
            const html = responseText;
            const parsedResponse = new DOMParser().parseFromString(html, 'text/html');
            let responseBlogGrid = parsedResponse.querySelector('#BlogArticlesGrid .blog-articles');
            if (responseBlogGrid.children.length) {
              let itemArray = Array.from(responseBlogGrid.children).reverse();
              itemArray.forEach((child) => {
                let clonedChild = child.cloneNode(true);
                this.blogGrid.prepend(clonedChild);
              });
            }

            const ogLoadMoreButton = document.querySelector('blog-load-previous a');
            const newLoadMoreSection = parsedResponse.querySelector('blog-load-previous');

            if (newLoadMoreSection) {
              let newLoadMoreButton = newLoadMoreSection.querySelector('a');
              ogLoadMoreButton.href = newLoadMoreButton.href;

              this.button.classList.remove('loading');
              if (this.loadingSpinner) {
                this.loadingSpinner.classList.add('hidden');
              }
            } else {
              ogLoadMoreButton.remove();
            }
          });
      }

      handleButtonClick(e) {
        e.preventDefault();
        if (this.children.length == 0) {
          return;
        }
        this.loadPrevPage();
      }
    }
  );
}
